import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const DriversRoute = lazy(() => import("@/pages/drivers.page"));

export const Route = createFileRoute("/drivers")({
  component: DriversRoute,
});
